import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  description: {
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
    marginRight: theme.spacing(2),
    display: 'inline-block',
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
    },
  },
  error: {
    position: 'absolute',
    right: 3,
    top: 3,
    height: 9,
    width: 9,
    borderRadius: 6,
    backgroundColor: 'rgb(244, 67, 54)',
  },
  edit: {
    display: 'inline-block',
    position: 'relative',
  },
  button: {
    display: 'inline-block',
    lineHeight: '1em',
    borderLeft: '1px solid rgba(0, 0, 0, 0.1)',
    paddingLeft: theme.spacing(1),
    marginLeft: theme.spacing(1),
    '& > *': {
      [theme.breakpoints.down('md')]: {
        padding: `${theme.spacing(1)} !important`,
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(-1),
      paddingLeft: 0,
      marginLeft: 0,
    },
  },
}))
